import React from 'react'
import { ProductSummary } from '@screens/Marketplace/components/NewMarketplace/ProductSummary.tsx'
import { useLazyScreenPreload } from '@src/navigation/utils'
import { labsImage } from '@assets/images'
import { useLabPanelsProducts } from '@screens/NutritionistHub/components/LabPanels/useLabPanelsProducts.ts'
import { Feature, useFeatureFlag } from '@components'

interface LabPanelsProductSummaryProps {
  onPress: () => void
}

export const LabPanelsProductSummary = ({ onPress }: LabPanelsProductSummaryProps) => {
  const fullscriptLabsEnabled = useFeatureFlag(Feature.FullscriptLabs)
  const { estimatedProductPrices } = useLabPanelsProducts()

  useLazyScreenPreload('LabPanelsScreen', {
    shouldPreload: !!estimatedProductPrices.length,
  })

  if (!fullscriptLabsEnabled || !estimatedProductPrices.length) {
    return null
  }

  const price = Math.min(...estimatedProductPrices.map((p) => p.estimatedPrice.total))

  return (
    <ProductSummary
      title="Lab Panels"
      description="Understand your metabolism and optimize your health."
      price={price}
      startPrice
      image={labsImage}
      imageStyle={styles.image}
      onPress={onPress}
    />
  )
}

const styles = {
  image: {
    alignSelf: 'center' as const,
    paddingHorizontal: 8,
  },
}
